import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Close from "../icons/Close";
import CheckMarkApprove from "../icons/CheckMarkApprove";

import { colors, TableColumnHeading } from "./index";

const browserIsIE = window.document.documentMode;

export const FeatureTableMobileColumnHeading = styled(TableColumnHeading)``;

const StyledFeatureTableMobileBullet = styled.td`
    display: flex;
    align-items: center;

    ${Close} {
        margin-right: 0.5rem;
        width: 0.625rem;
        height: auto;
        fill: ${colors.veryLightPinkTwo};
    }

    ${CheckMarkApprove} {
        margin-right: 0.5094rem;
        width: 0.6125rem;
        height: auto;
        fill: ${colors.royalBlue};
    }

    ${Close}, ${CheckMarkApprove} {
        ${browserIsIE && "height: 0.9375rem;"}
    }
`;

let FeatureTableMobileBullet = ({
    children,
    isFeature,
    className,
    ...otherProps
}) => {
    const Icon = isFeature ? CheckMarkApprove : Close;

    return (
        <StyledFeatureTableMobileBullet
            {...otherProps}
            className={className}
            alignItems="center"
        >
            <Icon />
            {children}
        </StyledFeatureTableMobileBullet>
    );
};

FeatureTableMobileBullet.propTypes = {
    isFeature: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.string
};

FeatureTableMobileBullet = styled(FeatureTableMobileBullet)``;
export { FeatureTableMobileBullet };

const FeatureTableMobileList = styled.tr`
    display: block;
    height: ${({ height }) => (height ? height : "auto")};
    padding-top: 1.4375rem;
    padding-left: 1.4406rem;

    ${FeatureTableMobileBullet} {
        margin-bottom: 0.5rem;
    }
`;

FeatureTableMobileList.propTypes = {
    height: PropTypes.string
};

export { FeatureTableMobileList };
